import React from "react";
import { formatNumber } from "utils/currencyFormat";
import { BtnSua } from "./ChucNang/BtnSua";
import { BtnChuyenKho } from "./ChucNang/ChuyenKho/BtnChuyenKho";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";

export const ContentTable = ({ listDataDanhSach, onSearch }) => {
  if (listDataDanhSach == undefined || listDataDanhSach.length === 0)
    return null;

  return listDataDanhSach?.map((item, index) => (
    <div className="custom-table-row" key={"item" + 1}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper color7">
          <p className="text-center">{index + 1}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm  action-cell">
        <span className="mobile-column-name">Mã tài sản</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.Code}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
        <span className="mobile-column-name">Tên tài sản</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.TenTaiSan}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
        <span className="mobile-column-name">Giá trị</span>
        <div className="center-wrapper color7">
          <p className="text-right">{formatNumber(item.GiaTriTaiSan)}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
        <span className="mobile-column-name">Đã khấu hao</span>
        <div className="center-wrapper color7">
          <p className="text-right"> {formatNumber(item.SoTien)}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-18 flex-basis-18-sm">
        <span className="mobile-column-name">Giá trị còn lại</span>
        <div className="center-wrapper color7">
          <p className="text-right">
            {" "}
            {formatNumber(item.GiaTriTaiSan - item.SoTien)}
          </p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-7 flex-basis-7-sm">
        <span className="mobile-column-name">Hiện trạng</span>
        <div className="center-wrapper color7">
          <p className="text-left">{item.TrangThaiTaiSanName}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Kho</span>
        <div className="center-wrapper color7">
          <p className="text-left">{item.StoreName}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-5 flex-basis-5-sm action-cell">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter">
            <BtnSua TaiSanID={item.TaiSanID} onSearch={onSearch} />
            <BtnChuyenKho TaiSanID={item.TaiSanID} onSearch={onSearch} />
            <BtnXoa TaiSanID={item.TaiSanID} onSearch={onSearch} />
          </div>
        </div>
      </div>
    </div>
  ));
};
